import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { dynamicImage } from "../utils";
import { routes } from "../routers/routes";
import SignInForm from "./SignInForm";
import { Image } from "../coreComponents/Image";
import ApiService from "../services/apiService";
import LoadingComponent from "../components/lodingComponent";
import CustomerService from './finalimg.png'
import Iroot from './iroot.png'
const Auth = () => {
  const [projectData, setProjectData] = useState<any>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const fetchProjects = async () => {
      try {
        const response = await ApiService.axiosApi(
          `/projectsettings/getallproject`,
          {
            method: "GET",
          },
        );
        if (response.success) {
          setProjectData(response.data.data[0].projectName);
        } else {
          console.log(
            response.message || response.status || "unable to get projects",
          );
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    fetchProjects();
  }, []);

  if (loading) {
    return <LoadingComponent />;
  }

  return (
    <>
   
    <Container fluid className="p-0 login-root">
      
      <div className="login-card login-dark flex-column p-0">
         <div className="mb-3">
            <img style={{
               width:'145px'
            }} src={Iroot} alt="" />
         </div>
        <div className="login-main" >
          <SignInForm />
        </div>
      </div>
    </Container>

    </>
  );
};

export default Auth;
